/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:59:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-29 15:54:09
 * @name: cookie数据
 * @Description: cookie数据
 * @FilePath: \preSaleNafterSaleBackstage\src\storage\cookie.js
 * @Author: DESKTOP-1QU67QM
 */
import Cookies from 'js-cookie';

const cookie = class {
    constructor() {
        this.cookie_title = 'preSaleNafterSaleBackstage_';
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取token
     * @return {String} token
     */
    getToken() {
        return Cookies.get(`${this.cookie_title}token`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置token
     */
    setToken(token) {
        Cookies.set(`${this.cookie_title}token`, token);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 移除token
     */
    removeToken() {
        Cookies.remove(`${this.cookie_title}token`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取路由权限列表
     * @return {Array} auth_list
     */
    getAuthList() {
        return Cookies.get(`${this.cookie_title}auth_list`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置路由权限列表
     */
    setAuthList(auth_list) {
        Cookies.set(`${this.cookie_title}auth_list`, auth_list);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 移除路由权限列表
     */
    removeAuthList() {
        Cookies.remove(`${this.cookie_title}auth_list`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取角色id
     * @return {String} role_id
     */
    getRoleId() {
        return Cookies.get(`${this.cookie_title}role_id`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置角色id
     */
    setRoleId(role_id) {
        Cookies.set(`${this.cookie_title}role_id`, role_id);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 移除角色id
     */
    removeRoleId() {
        Cookies.remove(`${this.cookie_title}role_id`);
    }
}

export default cookie;